import { brandName } from '@helpers/constants';
import { getNumberWithComma } from '@helpers/miscelleanous';

export const hasOffer = process.env.NEXT_PUBLIC_REFERRER_REWARD_MULTIPLIER > 1;

export const rewardForReferringTenFriends = getNumberWithComma(
    parseInt(
        process.env.NEXT_PUBLIC_REFERRER_REWARD_AMOUNT * 10
    )
);

export const newRewardForReferringTenFriends = getNumberWithComma(
    parseInt(
        process.env.NEXT_PUBLIC_REFERRER_REWARD_AMOUNT *
            process.env.NEXT_PUBLIC_REFERRER_REWARD_MULTIPLIER *
            10
    )
);

export const rewardForReferee = getNumberWithComma(parseInt(process.env.NEXT_PUBLIC_REFEREE_REWARD_AMOUNT));

export const newRewardForReferee = getNumberWithComma(parseInt(process.env.NEXT_PUBLIC_REFEREE_REWARD_AMOUNT * process.env.NEXT_PUBLIC_REFERRER_REWARD_MULTIPLIER));

export const rewardReferral = getNumberWithComma(
        parseInt(process.env.NEXT_PUBLIC_REFERRER_REWARD_AMOUNT)
    );

export const minRewardEligibilityAmount = getNumberWithComma(
    parseInt(
        process.env
            .NEXT_PUBLIC_MINIMUM_CUMULATIVE_INVESTMENT_AMOUNT_REFERRAL_REWARD
    )
);

export const halfOfMinRewardEligibilityAmount = getNumberWithComma(
    parseInt(
        process.env
            .NEXT_PUBLIC_MINIMUM_CUMULATIVE_INVESTMENT_AMOUNT_REFERRAL_REWARD /
            2
    )
);

export const referralRewardEligibilityDays = parseInt(
    process.env.NEXT_PUBLIC_REFERRAL_REWARD_ELIGIBILITY_DAYS
);

export const getReferAndEarnFaq = () => [
    {
        question: `Who can participate in the referral program?`,
        answer: `Any customer who has registered on ${brandName} is eligible to take part in the referral program and can refer their friends and family members. However, the customer will be eligible for receiving their referral reward only after completing their KYC and providing their bank account details.`,
    },
    {
        question: `How many people can I refer?`,
        answer: `There is no limit on the number of family members and friends that you can refer.`,
    },
    {
        question: `What is the minimum amount of investment my referral must make to be eligible for the program?`,
        answer: `The minimum amount of investment is ₹${minRewardEligibilityAmount} cumulatively across one or more investment opportunities available on the platform.`,
    },
    {
        question: `Can I refer my friend who is already an existing registered user on ${brandName}?`,
        answer: `No, all your referrals need to be new users who have registered on the ${brandName} platform using your referral link.`,
    },
    {
        question: `What would be my referral reward for referring 10 friends?`,
        answer: `Any user referring 10 friends will receive a referral reward of ₹${newRewardForReferringTenFriends}, while each of the 10 friends who were referred will be receiving a reward of ₹${newRewardForReferee} post making their qualified investments for a total of ₹${minRewardEligibilityAmount} across one or more investments.`,
    },
    {
        question: `When do I earn the referral reward?`,
        answer: `You will earn the reward once your referrals have made their first investment of at least ₹${minRewardEligibilityAmount} or more on ${brandName}.`,
    },
    {
        question: `Do I earn referral reward if my referral did not use my referral link?`,
        answer: `No. Your friends must use your referral link to register & make the required investment within ${referralRewardEligibilityDays} days for you and your friends to qualify for rewards.`,
    },
    {
        question: `Will I be eligible for the referral rewards if I haven't invested on the platform while my friend has made an investment?`,
        answer: `Yes, you will be eligible for the referral reward even if you haven't made an investment, but your referral has made the qualified required investment(s).`,
    },
    {
        question: `My friend made an investment before I could complete my KYC. Will I still be eligible for the referral rewards?`,
        answer: `You will be eligible for the referral rewards as and when you complete your KYC, and the rewards will be credited to your account on or before the 15th of the next month from the date of completion of your KYC.`,
    },
    {
        question: `What is the validity of the referral program?`,
        answer: `The referral program does not have an end date. But every referral reward is valid ONLY for ${referralRewardEligibilityDays} days from the date of registration of the referred user. Both the referrer and referee will NOT be eligible for rewards if the referee makes their first investment beyond ${referralRewardEligibilityDays} days after their registration date. To qualify for the rewards, all the referrals should have successfully invested at least ₹${minRewardEligibilityAmount} or more across one or more investment opportunities, and the referrer should have completed their KYC and provided their bank account details.`,
    },
    {
        question: `Will me and my friend be eligible for rewards if my friend makes two separate investments of ₹${halfOfMinRewardEligibilityAmount} each thereby achieving a minimum of ₹${minRewardEligibilityAmount} investment on the platform?`,
        answer: `Yes, you and your friend will be eligible for the reward when your friend makes a total investment of ₹${minRewardEligibilityAmount} or more split across multiple investment opportunities. The total investment of ₹${minRewardEligibilityAmount} or more should have been done within ${referralRewardEligibilityDays} days of registration.`,
    },
    {
        question: `Will I be eligible for receiving referral rewards if my friend makes an investment after ${referralRewardEligibilityDays} days of their registration date?`,
        answer: `No, you and your friend will NOT be eligible for receiving referral rewards if their first investment date falls after ${referralRewardEligibilityDays} days from the date of registration on the platform.`,
    },
    {
        question: `Where can I view my referrals?`,
        answer: `Your referrals and their eligibility status can be viewed in your profile Dashboard under the My Referrals section.`,
    },
    {
        question: `When will I get my pay-out?`,
        answer: `All referral rewards that you have earned in a month will be paid out on or before the 15th of the following month.`,
    },
    {
        question: `Will my referral link expire at any point of time?`,
        answer: `No, your referral link will not expire for any friend to whom it has been shared. Your friend can use it to register any time they wish but will have to make an investment within ${referralRewardEligibilityDays} days from the date of registration so that you and your friend enjoy the referral benefit.`,
    },
];
